import { gql } from '@apollo/client'
import { buildGraphqlQuery } from '@ztechapps/common.utils'

export const blogCategoryDefaultFragment = gql`
  fragment blogCategoryDefaultFragment on BlogCategory {
    _id
    name
    parent {
      _id
    }
  }
`

export const blogCategoryQueries = buildGraphqlQuery('BlogCategory', blogCategoryDefaultFragment)
